import View from './View';

import { endpoints } from './Config';

const toExport = {
   
    view: { endpoint: endpoints.view, component: View },
    base: endpoints.base
    
};

export default toExport;

